import { render, staticRenderFns } from "./AdvantageCard.vue?vue&type=template&id=5e22413f&scoped=true"
import script from "./AdvantageCard.vue?vue&type=script&lang=js"
export * from "./AdvantageCard.vue?vue&type=script&lang=js"
import style0 from "./AdvantageCard.vue?vue&type=style&index=0&id=5e22413f&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e22413f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e22413f')) {
      api.createRecord('5e22413f', component.options)
    } else {
      api.reload('5e22413f', component.options)
    }
    module.hot.accept("./AdvantageCard.vue?vue&type=template&id=5e22413f&scoped=true", function () {
      api.rerender('5e22413f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/service/self-select-stock/components/AdvantageCard.vue"
export default component.exports